//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { setPreciseAmount, buildSpecificationMaterials } from './ReportMaterialsHelperFunctions.js'

export default {
  props: {
    record: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    operation: {
      type: String,
      default: null
    },
    // ====================
    fixProjectKey: {
      type: String,
      default: null
    },
    fixProjectName: {
      type: String,
      default: null
    },
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    standardSpecification: {
      type: Array,
      default () {
        return []
      }
    },
    debits: {
      type: Array,
      default () {
        return []
      }
    },
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      debit: {
        toolKey: null,
        toolName: null,
        stockKey: null,
        stockName: null,
        amount: null,
        loops: null,
        hasLoops: false,
        projectKey: null,
        projectName: null,
        note: null,
        noted: null,
        sn: null,
        recId: null,
        df: null,
        comment: null,
        mountingId: null,
        demountingId: null,
        tag: null,
        isSegment: false,
        delivered: null
      },
      editedMaterial: null,

      originalAmount: null,
      originalProjectKey: null,

      amountAvailable: null,
      stocksAvailableForTool: [],

      setPreciseAmount: setPreciseAmount,

      optionsDebitDf: [
        {
          label: 'Да',
          value: true
        },
        {
          label: 'Нет',
          value: false
        },
        {
          label: 'Не выбрано',
          value: null
        }
      ],
      materialesAvailableOptions: [],
      useSpecification: true,
      selectedStandard: null,
      skipStockAmountReset: false
    }
  },
  computed: {
    ...mapGetters({
      stocks: 'getStocks'
    }),
    showSpecificationCheckbox: function () {
      return !this.isEdit && this.standardSpecification && this.standardSpecification.length > 0
    },
    materialesAvailableWithAmount: function () {
      const materials = JSON.parse(JSON.stringify(this.materialesAvailable || []))

      return materials
        .filter(material => material.amount && material.amount.length)
        .map(material => {
          const validIndexes = material.amount
            .map((amt, i) => amt > 0 ? i : -1)
            .filter(i => i !== -1)

          return {
            ...material,
            amount: validIndexes.map(i => material.amount[i]),
            stockKey: validIndexes.map(i => material.stockKey[i]),
            stockName: validIndexes.map(i => material.stockName[i]),
            isArchive: material.isArchive
              ? validIndexes.map(i => material.isArchive[i])
              : validIndexes.map(() => false)
          }
        })
        .filter(material => material.amount.length > 0)
    },
    specificationMaterials: function () {
      return buildSpecificationMaterials(
        this.standardSpecification,
        this.materialesAvailableWithAmount,
        this.materialesAvailable
      )
    },
    materialOptionsSource: function () {
      if (this.useSpecification && this.showSpecificationCheckbox) {
        return this.specificationMaterials
      }
      return this.materialesAvailableWithAmount
    },
    amountBelowStandard: function () {
      return this.debit.stockKey != null &&
        this.selectedStandard &&
        this.selectedStandard.count != null &&
        this.amountAvailable != null &&
        Number(this.amountAvailable) < Number(this.selectedStandard.count)
    },
    disabledButtonSaveDebit: function () {
      return !this.reportActionsAccess.editMaterials ||
              this.debit.toolKey == null ||
              this.debit.stockKey == null ||
              this.debit.amount == null ||
              this.debit.projectKey == null ||
              (this.debit.hasLoops && (this.debit.loops === '' || this.debit.loops == null || this.debit.loops < 0)) ||
              this.debit.amount <= 0 ||
              (this.amountAvailable != null && Number(this.debit.amount) > Number(this.amountAvailable))
    },
    showWarningMessageRewriteMounting: function () {
      if (this.debit && this.debit.mountingId && this.debit.toolKey) {
        const mounting = this.mountings.find(mounting => mounting.recId === this.debit.mountingId)
        return !!mounting && mounting.toolKey !== this.debit.toolKey
      } else {
        return false
      }
    },
    showWarningMessageRepeateDebit: function () {
      if (this.debit && this.debit.toolKey && !this.isEdit) {
        return this.debits.find(debit => debit.toolKey === this.debit.toolKey) != null
      } else {
        return false
      }
    },
    additionalFieldsActive: function () {
      return this.report.isFieldIncluded('mountingsAndDemountings')
    }
  },
  watch: {
    useSpecification: function () {
      if (this.isEdit) {
        return
      }
      if (this.editedMaterial && !this.materialOptionsSource.find(m => m.toolKey === this.editedMaterial.toolKey)) {
        this.editedMaterial = null
        this.setMaterial(null)
      }
      this.materialesAvailableOptions = this.materialOptionsSource
    },
    'debit.toolKey': function (value, prevValue) {
      if (prevValue !== null && !this.isEdit) {
        this.debit.stockKey = null
        this.debit.stockName = null
      }

      if (!this.debit.toolKey) {
        this.debit.toolName = null
        this.selectedStandard = null
        return
      }

      const result = this.materialOptionsSource.find(material => {
        if (this.isEdit) {
          return (material.toolKey === this.debit.toolKey && material.stockKey && material.stockKey.includes(this.debit.stockKey))
        } else {
          return material.toolKey === this.debit.toolKey
        }
      }) || this.materialesAvailableWithAmount.find(material => {
        if (this.isEdit) {
          return (material.toolKey === this.debit.toolKey && material.stockKey.includes(this.debit.stockKey))
        } else {
          return material.toolKey === this.debit.toolKey
        }
      })

      if (result) {
        this.debit.toolName = result.toolName
        this.selectedStandard = result.standard || null
        if (!this.isEdit) {
          this.debit.hasLoops = !!result.hasLoops
          this.debit.loops = null
        }

        this.stocksAvailableForTool = []
        if (result.outOfStock || !(result.stockKey && result.stockKey.length)) {
          for (let i = 0; i < this.stocks.length; i++) {
            this.stocksAvailableForTool[i] = {
              stockKey: this.stocks[i].stockKey,
              stockName: this.stocks[i].stockName,
              toolName: result.toolName,
              toolKey: result.toolKey,
              amount: 0,
              isArchive: false,
              unit: result.unit,
              unit2: result.unit2,
              maxUnit2: result.maxUnit2,
              outOfStock: true
            }
          }
          if (this.stocksAvailableForTool.length === 1) {
            this.skipStockAmountReset = true
            this.debit.stockKey = this.stocksAvailableForTool[0].stockKey
            this.debit.stockName = this.stocksAvailableForTool[0].stockName
          }
        } else if (result.stockKey && result.amount) {
          for (let i = 0; i < result.stockKey.length; i++) {
            this.stocksAvailableForTool[i] = {
              stockKey: result.stockKey[i],
              stockName: result.stockName[i],
              toolName: result.toolName,
              toolKey: result.toolKey,
              amount: result.amount[i],
              isArchive: result.isArchive ? result.isArchive[i] : false,
              unit: result.unit,
              unit2: result.unit2,
              maxUnit2: result.maxUnit2
            }
          }
          if (result.stockKey.length === 1) {
            this.skipStockAmountReset = true
            this.debit.stockKey = result.stockKey[0]
            this.debit.stockName = result.stockName[0]
          }
        } else {
          for (let i = 0; i < this.stocks.length; i++) {
            this.stocksAvailableForTool[i] = {
              stockKey: this.stocks[i].stockKey,
              stockName: this.stocks[i].stockName,
              toolName: result.toolName,
              toolKey: result.toolKey,
              amount: Number.POSITIVE_INFINITY,
              isArchive: false,
              unit: result.unit,
              unit2: result.unit2,
              maxUnit2: result.maxUnit2
            }
          }
        }
      } else {
        this.selectedStandard = null
        // Обработка случая, когда материала нет среди доступных
        this.materialesAvailableWithAmount.push({
          stockKey: [this.debit.stockKey],
          stockName: [this.debit.stockName],
          toolName: this.debit.toolName,
          toolKey: this.debit.toolKey,
          amount: [0],
          unit: this.debit.unit,
          unit2: this.debit.unit2,
          maxUnit2: this.debit.maxUnit2
        })
        this.stocksAvailableForTool = [
          {
            stockKey: this.debit.stockKey,
            stockName: this.debit.stockName,
            toolName: this.debit.toolName,
            toolKey: this.debit.toolKey,
            amount: 0,
            unit: this.debit.unit,
            unit2: this.debit.unit2,
            maxUnit2: this.debit.maxUnit2
          }
        ]
      }

      this.updateDebitStockData()
      if (!this.isEdit) {
        this.applyStandardDefaults()
      }
    },
    'debit.stockKey': function (value, prevValue) {
      if (prevValue !== null && !this.isEdit && !this.skipStockAmountReset) {
        this.debit.amount = null
      }
      this.skipStockAmountReset = false

      if (!this.debit.stockKey) {
        this.debit.stockName = null
        return
      }

      this.updateDebitStockData()

      if (this.isEdit) {
        for (let i = 0; i < this.materialesAvailableWithAmount.length; i++) {
          if (this.materialesAvailableWithAmount[i].toolKey == this.debit.toolKey) {
            for (let j = 0; j < this.materialesAvailableWithAmount[i].stockKey.length; j++) {
              if (this.materialesAvailableWithAmount[i].stockKey[j] === this.debit.stockKey) {
                this.amountAvailable = this.materialesAvailableWithAmount[i].amount[j] + this.debit.amount
                break
              }
            }
          }
        }
      } else {
        this.applyStandardDefaults()
      }
    },
    'debit.projectKey': function () {
      const result = this.projects.find(project => project.projectKey === this.debit.projectKey)
      if (result) {
        this.debit.projectName = result.projectName
      }
    }
  },
  created: function () {
    if (this.isEdit) {
      const record = this.record
      this.setDebitValues(record)
    } else {
      this.setDebitValues(null)

      // Проект по умолчанию или фиксированный
      const lastDebit = this.debits[this.debits.length - 1]

      if (this.fixProjectKey && this.projects.find(p => p.projectKey === this.fixProjectKey)) {
        this.debit.projectKey = this.fixProjectKey
        this.debit.projectName = this.fixProjectName
      } else if (this.debits && this.debits.length && this.projects.find(p => p.projectKey === lastDebit.projectKey)) {
        this.debit.projectKey = lastDebit.projectKey
        this.debit.projectName = lastDebit.projectName
      } else if (this.projects && this.projects.length) {
        this.debit.projectKey = this.projects[0].projectKey
        this.debit.projectName = this.projects[0].projectName
      }

      if (this.showSpecificationCheckbox && this.specificationMaterials.length === 1) {
        const specificationMaterial = this.specificationMaterials[0]
        this.editedMaterial = { toolKey: specificationMaterial.toolKey, toolName: specificationMaterial.toolName }
        this.setMaterial(specificationMaterial)
      }
    }
    this.materialesAvailableOptions = this.materialOptionsSource
  },
  methods: {
    onAddDebit: function (operation, demountingId) {
      // TODO
    },
    onEditDebit: function (record) {
      // TODO
    },
    onSaveDebit: function () {
      if (this.isEdit) {
        const amountChanged = Number(this.debit.amount) !== Number(this.originalAmount)
        const projectChanged = this.debit.projectKey !== this.originalProjectKey
        if (amountChanged || projectChanged) {
          this.debit.delivered = false
        }
      }
      this.$emit('save', { debit: this.debit, amountAvailable: this.amountAvailable })
      this.setDebitValues(null)
    },
    onCloseDebit: function () {
      this.$emit('close')
      this.setDebitValues(null)
    },
    setDebitValues: function (row) {
      if (row) {
        this.debit.toolKey = row.toolKey
        this.debit.toolName = row.toolName
        this.editedMaterial = { toolKey: row.toolKey, toolName: row.toolName }
        this.debit.stockKey = row.stockKey
        this.debit.stockName = row.stockName
        this.debit.amount = row.amount
        this.debit.loops = row.loops
        this.debit.hasLoops = row.hasLoops
        this.debit.unit = row.unit
        this.debit.unit2 = row.unit2
        this.debit.maxUnit2 = row.maxUnit2
        this.debit.projectKey = row.projectKey
        this.debit.projectName = row.projectName
        this.debit.note = row.note
        this.debit.noted = row.noted
        this.debit.sn = row.sn
        this.debit.recId = row.recId
        this.debit.df = row.df
        this.debit.tag = row.tag
        this.debit.comment = row.comment
        this.debit.mountingId = row.mountingId
        this.debit.demountingId = row.demountingId
        this.debit.isSegment = row.isSegment
        this.debit.delivered = row.delivered
        this.originalAmount = row.amount
        this.originalProjectKey = row.projectKey
      } else {
        this.debit.toolKey = null
        this.debit.toolName = null
        this.debit.stockKey = null
        this.debit.stockName = null
        this.debit.amount = null
        this.debit.loops = null
        this.debit.hasLoops = false
        this.debit.unit = null
        this.debit.unit2 = null
        this.debit.maxUnit2 = null
        this.debit.projectKey = null
        this.debit.projectName = null
        this.debit.note = null
        this.debit.noted = null
        this.debit.sn = null
        this.debit.recId = null
        this.debit.df = null
        this.debit.tag = null
        this.debit.comment = null
        this.debit.mountingId = null
        this.debit.demountingId = null
        this.debit.isSegment = false
        this.debit.delivered = null
        this.editedMaterial = null
        this.originalAmount = null
        this.originalProjectKey = null
        this.selectedStandard = null
      }
    },

    // ==========
    inputAmount2: function (result) {
      if (result) {
        this.$set(this.debit, 'amount', Math.round((result / this.debit.maxUnit2) * 1000) / 1000)
      } else {
        this.$set(this.debit, 'amount', null)
      }
    },

    placeholderAmount: function () {
      return this.debit.toolKey != null ? (this.debit.stockKey != null ? ('Доступно ' + this.amountAvailable + ' ' + this.debit.unit) : 'Выберите склад') : 'Выберите материал'
    },
    placeholderAmount2: function () {
      return this.debit.toolKey != null ? (this.debit.stockKey != null ? ('Доступно ' + this.amountAvailable * this.debit.maxUnit2 + ' ' + this.debit.unit2) : 'Выберите склад') : 'Выберите материал'
    },
    onSelectedProject: function (projectKey) {
      if (projectKey) {
        this.debit.projectKey = projectKey
        this.debit.projectName = this.projects.find(item => item.projectKey == projectKey).projectName
      } else {
        this.debit.projectKey = null
        this.debit.projectName = null
      }
    },
    getDebitDemountingName: function () {
      const optionsSelected = this.serviceObject ? this.demountings.filter((demounting) => {
        return demounting.serviceObjectKey === this.serviceObject.key
      }) : this.demountings
      const id = this.debit.demountingId
      return optionsSelected ? optionsSelected.find(item => item.recId == id).toolName : 'Не выбран'
    },
    onFilterMaterials (val, update, abort) {
      if (val === '' || val === null) {
        update(() => {
          this.materialesAvailableOptions = this.materialOptionsSource
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.materialesAvailableOptions = this.materialOptionsSource.map(a => ({ ...a })).filter(function (r) {
          return r.toolName.toLowerCase().indexOf(needle) > -1
        })
      })
    },
    setMaterial: function (material) {
      this.debit.toolKey = material ? material.toolKey : null
      this.debit.toolName = material ? material.toolName : null
      this.selectedStandard = material && material.standard ? material.standard : null
      if (!material) {
        this.debit.stockKey = null
        this.debit.stockName = null
        this.debit.amount = null
        this.debit.unit = null
        this.debit.unit2 = null
        this.debit.maxUnit2 = null
        this.debit.hasLoops = false
        this.debit.loops = null
        this.amountAvailable = null
        this.stocksAvailableForTool = []
        this.selectedStandard = null
      }
    },
    applyStandardDefaults: function () {
      if (!this.selectedStandard || this.isEdit) {
        return
      }
      if (this.selectedStandard.count != null && this.debit.stockKey != null) {
        this.debit.amount = this.selectedStandard.count
        this.setPreciseAmount(this.debit)
      }
      if (this.selectedStandard.project && this.selectedStandard.project.key) {
        const project = this.projects.find(p => p.projectKey === this.selectedStandard.project.key)
        if (project) {
          this.debit.projectKey = project.projectKey
          this.debit.projectName = project.projectName
        }
      }
    },
    updateDebitStockData: function () {
      const result = this.stocksAvailableForTool.find(stock => stock.stockKey === this.debit.stockKey)
      if (result) {
        this.debit.stockName = result.stockName
        this.debit.unit = result.unit
        this.debit.unit2 = result.unit2
        this.debit.maxUnit2 = result.maxUnit2
        this.amountAvailable = result.amount
      }
    }
  }
}

